<template>

	<div>

		<div class="" style="padding-top:0px;">

			<div class="content">

				<div v-if="!createstatus && !editstatus">
					<div class="columns is-striped">
						<div class="column" style="display:flex;">

							<button class="button is-info" @click="createstatus = true" :disabled="!canManageContracts">Create Contract</button>

						</div>
						<div class="column has-text-right">
							<b-field>
		            <b-checkbox size="is-medium" v-model="show_archived">Show Archived</b-checkbox>
			        </b-field>
						</div>
					</div>

					<div>
						<table class="firm-associaions-and-contracts">
							<template v-for="(row, i) in visibleRows">
								<tr :class="{ 'is-last-row-for-association': row.is_last_row_for_firm }" :key="row.key">
									<td>
										<span v-if="row.is_first_row_for_firm">
											{{ row.assoc.firm.name }}
										</span>
									</td>
									<td>
										<div v-if="row.is_first_row_for_firm">
											<button :class="'button ' + hasTag(row.assoc.tags, 'vendor')" @click="attachTag(' vendor ', row.assoc, $event)">Vendor</button>
											<button :class="'button ' + hasTag(row.assoc.tags, 'customer')" @click="attachTag('customer', row.assoc, $event)">Customer</button>
											<!--
											<template v-if="row.id != firm.id">
												<button class="button is-small is-warning" v-if="row.archived_at == null" @click="toggleArchive(row, $event)">Archive</button>
												<button class="button is-small is-dark" v-else @click="toggleArchive(row, $event)">Restore</button>
											</template>
											-->
										</div>
									</td>
									<td>{{ row.contract ? row.contract.name : '' }}</td>
									<td>
										<actions
											v-if="row.contract && row.contract.id"
											:contract="row.contract"
											@contract-archived="onContractArchivedOrRestored"
											@contract-restored="onContractArchivedOrRestored"
											:can-manage-contract="canManageContract(row.contract.id)"
											:editstatus.sync="editstatus"
											:createstatus.sync="createstatus"
											:editdata.sync="editdata">
										</actions>
									</td>
								</tr>
							</template>
						</table>
					</div>

					</div>

				<create-contract :create.sync="createstatus" :organization="organization" :contractors="contractorsAvailable" v-if="createstatus"></create-contract>

				<edit-contract :edit.sync="editstatus" :organization="organization" :firm="firm" :contractors="contractorsAvailable" :editdata="editdata" :can-manage-contract="canManageContract(editdata.id)" v-if="editstatus"></edit-contract>

			</div>

		</div>

	</div>

</template>

<script>

import { ContractService } from "@/services/contract.service";
import { AssociatedService } from "@/services/associated.service";
import { FirmService } from "@/services/firm.service";
import CreateContract from "./create";
import EditContract from "./edit";
import Actions from "./partials/actions";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import Roles from "@/helpers/roles";

const getStartCodeTypeValue = attributes => {
	let value;
	let attribute = attributes.find(attr => {
		return attr.code == '[SYSTEM][ORDER][CODE_CHAIN][START]';
	});
	if (attribute) {
		value = attribute.pivot ? attribute.pivot.value : attribute.value;
	}
	return value;
};

export default {
	components: { CreateContract, EditContract, Actions },
	props: ['organization', 'firm'],
  data() {
    return {
    	show_archived: false,
    	code_sets: [],
    	contracts: [],
    	childrens: [],
    	createstatus: false,
    	editstatus: false,
    	editdata: [],
    	archiveLoading: false,
    	tags: [],
			customerButtonStatus: false,
			customerLoadingStatus: false,
			associated: [],
    }
  },
  computed: {

  	visibleAssociations() {
  		// Weird that the firm is nested under firm_firm.firm_name so we adjust here.
  		let associations = [];
  		this.associated.forEach(a => {
  			let transformed = _.omit(a, ['firm_name']);
  			transformed.firm = a.firm_name;
  			if (this.show_archived || ! transformed.archived_at) {
	  			associations.push(transformed);
  			}
  		});
  		associations = _.sortBy(associations, 'firm.name');
  		return associations;
  	},

  	visibleContracts() {
  		let contracts = [];
  		this.contracts.forEach(c => {
  			if (this.show_archived || ! c.archived_at) {
  				contracts.push(c);
  			}
  		});
  		return contracts;
  	},

  	visibleRows() {
  		let rows = [];
  		this.visibleAssociations.forEach(assoc => {
  			const baseRow = Object.assign(
  				{ is_first_row_for_firm: true, is_last_row_for_firm: true },
  				{ contract: null },
  				{ assoc }
  			);
  			let contracts = this.getRelatedContracts(assoc.firm.id);
  			if ( ! contracts.length) {
  				rows.push(Object.assign({}, baseRow));
  			}
  			else {
  				const contract_count = contracts.length;
  				contracts.forEach((c, index) => {
  					let row = Object.assign({}, baseRow, { contract: c });
  					if (index !== 0) {
  						row.is_first_row_for_firm = false;
  					}
  					if (index != contract_count -1) {
  						row.is_last_row_for_firm = false;
  					}
  					rows.push(row);
  				});
  			}
  		});
  		rows = rows.map(r => {
  			let key_parts = [r.assoc.id, (r.contract ? r.contract.id : _.random(1, 100)) ]
  			r.key = key_parts.toString();
  			return r;
  		});
  		return rows;
  	},

  	contractorsAvailable() {
  		let firms = [];
  		let authUser = this.$store.state.Auth.user;
  		this.childrens.forEach(firmChild => {
  			let firm = Object.assign({}, { id: firmChild.id }, firmChild.attributes);
  			firms.push(firm);
  		});
  		// firms = firms.filter(firm => {
  		// 	return (firm.id == authUser.firmId || firm.managed_by == authUser.firmId);
  		// });
  		firms = _.sortBy(firms, 'name');
  		return firms;
  	}
  },
  methods: {
  	// Implemented getRouteData() with the hope that existing async data methods
  	// could get slotted in here for more predictable component data loading.
  	loadRouteData() {
  		return this.getRouteData().then(data => {
  			this.code_sets = data.code_sets
  		});
  	},
  	getRouteData() {
  		return new Promise((resolve, reject) => {
  			let data = { code_sets: [] };
  			Promise.all([
  				// this.getCodeSets(),
  			])
  			.then(all => {
  				// data.code_sets = all[0];
  				resolve(data);
  			}).catch(err => {
  				reject(err);
  			});
  		});
  	},
  	getCodeSets() {
  		return ContractService.getCodeSets();
  	},
  	getRelatedContracts(firm_id) {
  		let related = [];
  		this.visibleContracts.forEach(c => {
  			if (c.contractee_firm_id == firm_id || c.contractor_firm_id == firm_id) {
  				if (this.organization.id != firm_id) {
  					related.push(c);
  				}
  				else if (this.organization.id == firm_id
  						&& c.contractee_firm_id == this.organization.id
  						&& c.contractor_firm_id == this.organization.id) {
  					related.push(c);
  				}
  			}
  		});
  		related = _.sortBy(related, 'name');
  		return related;
  	},
		fetch() {
			ContractService.all({
				includes: 'creator,attributes,contractee,contractor,permissions,typeTag',
			}).then(response => {
            	let contracts = JsonDenormalizer.denormalize(response);
            	this.contracts = _.sortBy(contracts, c => {
            		return c.name.toLowerCase();
            	});
				// this.contracts = response;
			});
		},
		getAssociated() {
			// let ids = this.firm.firm.associated.map(element => element.id);
			AssociatedService.getAssociated({id: this.organization.id, includes: 'tags'}).then(response => {
				let data = Object.values(response);
				this.associated = data.sort((a, b) => {
					var x = a.firm_name.name.toLowerCase(), y = b.firm_name.name.toLowerCase();
					return x < y ? -1 : x > y ? 1 : 0;
				});
			});
		},

		fetchFirm() {

			FirmService.show(this.organization.id, {includes: 'children'}).then(response => {

				// console.log(response);

				if (typeof response.included !== 'undefined') {

					this.childrens = response.included.filter(element => {

						return element.type == 'firm-children';

					});

				}


			});

		},

		async getTags() {
			await AssociatedService.getTags({id: this.firm.id}).then(response => {
				this.tags = response;
			});
		},
		async attachTag(tag, firm, event) {
			await AssociatedService.attachTag({id: firm.id, tag: tag}).then(response => {
  				event.target.classList.toggle('is-info');
  				this.$buefy.toast.open({
					message: "Success",
					type: "is-success",
					position: "is-top-right"
		        });
				// console.log(response);
				// this.tags = response;
			});
		},

		toggleArchive(row, event) {
			AssociatedService.toggleArchive({id: row.id}).then(response => {
				// if (row.archived_at == null) {
    //             	event.target.innerHTML = 'Restore';
				// }else {
    //             	event.target.innerHTML = 'Archive';
				// }
    // 	        event.target.classList.toggle('is-warning');
    // 	        event.target.classList.toggle('is-dark');
    			this.getAssociated();
    	        this.$buefy.toast.open({
					message: "Success",
					type: "is-success",
					position: "is-top-right"
		        });
			});
		},
		hasTag(tags, type) {
			if (tags.length) {
				let exist = tags.find(element => {
					return element.name.toLowerCase() == type && element.pivot.archived_at == null;
				});
				return exist ? 'is-info' : '';
			}
			// console.log(tags);
		},

		canManageContracts() {
			let can = false;
			const authUser = this.$store.state.Auth.user;
			const authUserFirm = _.get(authUser, 'firm', {});
			if ( ! authUserFirm.id) {
				const hasPermission = this.$store.getters['Auth/hasPermission']('can manage contracts');
				can = hasPermission && ( ! authUserFirm.managed_by || authUserFirm.managed_by == authUser.firmId);
			}

			return can;
		},

		canManageContract(contract_id) {
			let can = false;
			const user = this.$store.state.Auth.user;
			const contract = this.contracts.find(c => c.id == contract_id);
			if (contract) {
				can = ((user.firmId == _.get(contract, 'creator.firmId', null)) && this.canManageContracts);
				if ( ! can) can = this.$store.getters["Auth/hasRole"](Roles.SUPERADMIN);
			}
			return can;
		},

		onContractArchivedOrRestored(payload) {
			// If this gets out of sync, we could just force a reload of all data
			// by calling something like this.fetch() or this.loadRouteData().
			// For now, we just try updating the contract details in-place.
			const { id, archived_at } = payload;
			this.contracts.forEach((c, index) => {
				if (c.id == id) {
					this.$set(this.contracts[index], 'archived_at', archived_at);
				}
			})
		},

	},

	watch: {

		'organization.id'(value) {
			this.fetch();
			this.fetchFirm();
			this.getTags();
			this.getAssociated();
			this.loadRouteData();
			this.createstatus = false;
			this.editstatus = false;

		},

		createstatus(value) {

			// if (!value) {

				this.fetch()

			// }

		},

		editstatus(value) {

			// if (!value) {

				this.fetch()

			// }

		}

	},

	mounted() {
		this.fetch();
		this.fetchFirm();
		this.getTags();
		this.getAssociated();
		this.loadRouteData();
	}

}

</script>

<style scoped>
	table.firm-associaions-and-contracts :not(tr.is-last-row-for-association) td {
		border-bottom: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/pages/Contracts/index.vue